import styled from 'styled-components'

const Main = styled.div`
  width: 1080px;
`
export default Main
